import React, { Fragment } from "react";
import moment from "moment";
import {
  TypographyT40,
  TypographyT41,
  TypographyT42,
  TypographyT44,
  TypographyT53,
} from "Components/Common/Typography/index";
import {
  TBody,
  TFoot,
  THead,
  Table,
  TableWrapper,
  Td,
  Th,
  Tr,
} from "Components/Common/Table/TableT1";
import { ButtonT11, ButtonT3 } from "Components/Common/Button/index";
import { getToFixedValue } from "Utils/index";
const MaterialDetailsTable = (props) => {
  const { selectMaterialPackingList = [] } = props;

  console.log("selectMaterialPackingList:", selectMaterialPackingList);

  const handleGetTotalGrossWeight = () => {
    let totalGrossWeight = 0;
    totalGrossWeight = selectMaterialPackingList.reduce((tv, ce) => {
      return tv + +ce.gross_weight;
    }, 0);

    return totalGrossWeight;
  };

  const handleGetTotalTareWeight = () => {
    let totalTareWeight = 0;
    totalTareWeight = selectMaterialPackingList.reduce((tv, ce) => {
      return tv + +ce.tare_weight;
    }, 0);

    return totalTareWeight;
  };

  const handleGetTotalNetWeight = () => {
    // let totalNetWeight = 0
    // totalNetWeight = selectMaterialPackingList.reduce((tv, ce) => {
    //   return tv + (+ce.gross_weight - +ce.tare_weight)
    // }, 0)

    // return totalNetWeight
    let totalNetWeight = 0;
    totalNetWeight = selectMaterialPackingList.reduce((tv, ce) => {
      return tv + +ce.net_weight;
    }, 0);

    return totalNetWeight;
  };

  const handleGetTotalVolume = () => {
    let totalVolume = 0;
    totalVolume = selectMaterialPackingList.reduce((tv, ce) => {
      return tv + +ce.volume;
    }, 0);

    return getToFixedValue(totalVolume);
  };
  return (
    <Fragment>
      <TableWrapper
        style={{
          height: "calc(100vh - 300px)",
        }}
      >
        <Table>
          <THead>
            <Tr>
              <Th>SI No.</Th>
              {/* <Th>Package No.</Th> */}
              <Th>Desmet Package No.</Th>
              <Th>Type of Package</Th>
              <Th>Item No.</Th>
              <Th>Gross Weight(Kg)</Th>
              {/* <Th>Tare Weight (Kg)</Th> */}
              <Th>Net Weight (Kg)</Th>
              <Th>Length (cm)</Th>
              <Th>Width (cm)</Th>
              <Th>Height (cm)</Th>
              <Th>Vol (m3)</Th>
              <Th>Qty</Th>
              <Th>Unit</Th>
              <Th>Material Desc.</Th>
              <Th>Remarks</Th>
            </Tr>
          </THead>
          <TBody>
            {selectMaterialPackingList.map((ele, ind) => {
              return (
                <Fragment key={ind}>
                  <Tr>
                    <Td>
                      <TypographyT40>{ind + 1}</TypographyT40>
                    </Td>
                    {/* <Td>
                      <TypographyT40>{ele.package_number || "-"}</TypographyT40>
                    </Td> */}
                    <Td>
                      <TypographyT40>
                        {ele.desmet_package_no || "-"}
                      </TypographyT40>
                    </Td>
                    <Td>
                      <TypographyT40>
                        {ele.type_of_packing || "-"}
                      </TypographyT40>
                    </Td>
                    <Td>
                      <TypographyT40>
                        {ele.item_number || "-"}
                      </TypographyT40>
                    </Td>
                    <Td>
                      <TypographyT40>{ele.gross_weight || "-"}</TypographyT40>
                    </Td>
                    {/* <Td>
                      <TypographyT40>{ele.tare_weight || "-"}</TypographyT40>
                    </Td> */}
                    <Td>
                      {/* <TypographyT40>
                        {ele.gross_weight
                          ? ele.gross_weight - ele.tare_weight
                          : "-"}
                      </TypographyT40> */}
                      <TypographyT40>{ele.net_weight || "-"}</TypographyT40>
                    </Td>
                    <Td>
                      <TypographyT40>{ele.length || "-"}</TypographyT40>
                    </Td>
                    <Td>
                      <TypographyT40>{ele.width || "-"}</TypographyT40>
                    </Td>
                    <Td>
                      <TypographyT40>{ele.height || "-"}</TypographyT40>
                    </Td>
                    <Td>
                      <TypographyT40>{getToFixedValue(ele.volume) || "-"}</TypographyT40>
                    </Td>
                    <Td>
                      <TypographyT40>{ele.packing_qty || "-"}</TypographyT40>
                    </Td>
                    <Td>
                      <TypographyT40>{ele.packing_unit || "-"}</TypographyT40>
                    </Td>
                    <Td>
                      <TypographyT40>{ele.material_des || "-"}</TypographyT40>
                    </Td>
                    <Td>
                      <TypographyT40>{ele.remarks || "-"}</TypographyT40>
                    </Td>
                  </Tr>
                </Fragment>
              );
            })}
          </TBody>
          <TFoot>
            <Tr>
              <Td
                colSpan={4}
                style={{ borderTop: "1px solid rgba(82, 138, 234, 0.7)" }}
              >
                <TypographyT53>Total</TypographyT53>
              </Td>
              <Td style={{ borderTop: "1px solid rgba(82, 138, 234, 0.7)" }}>
                <TypographyT53>{handleGetTotalGrossWeight()}</TypographyT53>
              </Td>
              {/* <Td style={{ borderTop: '1px solid rgba(82, 138, 234, 0.7)' }}>
                <TypographyT53>
                  {handleGetTotalTareWeight()}
                </TypographyT53>
              </Td> */}
              <Td style={{ borderTop: "1px solid rgba(82, 138, 234, 0.7)" }}>
                <TypographyT53>{handleGetTotalNetWeight()}</TypographyT53>
              </Td>
              <Td
                colSpan={3}
                style={{ borderTop: "1px solid rgba(82, 138, 234, 0.7)" }}
              ></Td>
              <Td style={{ borderTop: "1px solid rgba(82, 138, 234, 0.7)" }}>
                <TypographyT53>{handleGetTotalVolume()}</TypographyT53>
              </Td>
              <Td
                colSpan={4}
                style={{ borderTop: "1px solid rgba(82, 138, 234, 0.7)" }}
              ></Td>
            </Tr>
          </TFoot>
        </Table>
      </TableWrapper>
    </Fragment>
  );
};

export default MaterialDetailsTable;
